<template>
  <fin-select-box v-model="selectedCountry"
                  :items="countryList"
                  :label="label"
                  return-as-object
                  selectBoxItemTitle="title"
                  selectBoxItemValue="id"/>
</template>

<script>
import countries from "i18n-iso-countries"
import FinSelectBox from "@/components/common/SelectBox"

countries.registerLocale(require("i18n-iso-countries/langs/en.json"))
countries.registerLocale(require("i18n-iso-countries/langs/de.json"))

export default {
  name: "FinCountrySelector",
  components: {
    FinSelectBox
  },
  props: {
    /** The selected country  */
    value: {
      type: [Object, String]
    },
    /** The language to display the countries in (available: de / en) */
    lang: {
      type: String,
      default: 'de',
      validator(value) {
        return ['de', 'en'].indexOf(value) !== -1
      }
    },
    /** The label for the country selector **/
    label: {
      type: String,
      default: 'Land'
    },
    /** If set, the countries are sorted by name. Default: the country of the `lang` prop is set as first element */
    alphabeticalOrder: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedCountry: this.value
    }
  },
  computed: {
    countryList() {
      let allCountries = countries.getNames(this.lang, {select: "official"})
      let res = []

      Object.entries(allCountries).forEach(([key, value]) => res.push({id: key, title: value}))
      const langIndex = res.findIndex(r => r.id === this.lang.toUpperCase())

      // default: set display language at first position
      if (!this.alphabeticalOrder && langIndex !== -1) {
        res.unshift(res.splice(langIndex, 1)[0])
      }

      return res
    },
  },
  watch: {
    selectedCountry(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>

</style>
